class PlansController {
  constructor($state,Plans) {
    "ngInject";
    this.$state = $state;
    this.name = 'plans';
    this.isAnnual = true;
    this.plans = Plans.getPlans();
  }

  selectPlan(planId) {
    this.$state.go('onboarding.payment', {
      planId: planId
    });
  }
}

export default PlansController;



// WEBPACK FOOTER //
// ./client/app/components/home/onboarding/plans/plans.controller.js